import React from "react";
import moment from "moment";
import $ from "jquery";
import { LenguageTabla } from "../../Comunes/LenguajeTabla/LenguajeTabla";
import ReactDOM from "react-dom";

export default class ResultadoConsultaAutorizaciones extends React.Component {
  constructor(props) {
    super(props);

    this.redireccionarDetalles = this.redireccionarDetalles.bind(this);
  }

  async componentDidMount() {
    this.CargarDatatable(this.props.datos);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.datos !== this.props.datos) {
      this.CargarDatatable(this.props.datos);
    }
  }

  redireccionarDetalles = async (data) => {
    await this.props._CargarDetalles(data);
    this.setState({
      verDatatable: this.props.mostrarDatatable,
    });
  };

  CargarDatatable(datos) {
    this.$el = $(this.el);
    $.fn.dataTable.ext.errMode = "throw";
    $.fn.dataTable.moment("DD/MM/YYYY hh:mm A");
    $.fn.dataTable.moment("DD/MM/YYYY");

    this.$el.DataTable({
      language: LenguageTabla,
      iDisplayLength: 10,
      stateSave: true,
      processing: true,
      destroy: true,
      data: datos,
      columns: [
        {
          data: null,
          render: function (data) {
            return (
              "<button className='js-detalle' >" +
              data.numeroAutorizacionFormateado +
              "</button>"
            );
          },
        },
        { data: "tipoAutorizacion.descripcion" },
        { data: "entidadAutorizada.alias" },
        { data: "identificacion.tipoPersona.nombre" },
        { data: "identificacion.codigo" },
        { data: "nombrePersonaAutoriza" },
        { data: "fechaTramite" },
        {
          data: "fechaTramite",
          render: function (data) {
            return moment(data).format("DD/MM/YYYY hh:mm A");
          },
        },
        { data: "usuarioTramite" },
        { data: "estadoAutorizacion.prefijo" },
        {
          data: "finRelacionCrediticia",
          render: function (data) {
            if (data != null) {
              return moment(data).format("DD/MM/YYYY");
            } else {
              return "";
            }
          },
        },
      ],
      order: [6, "desc"],
      columnDefs: [
        {
          targets: [6],
          visible: false,
          orderable: true,
        },
        {
          targets: [0],
          createdCell: (td, cellData, rowData, row, col) => {
            ReactDOM.render(
              <button
                className="btn btn-link"
                onClick={this.redireccionarDetalles.bind(this, cellData)}
              >
                {cellData.numeroAutorizacionFormateado}
              </button>,
              td
            );
          },
        },
      ],
    });
  }

  render() {
    return (
      <div>
        {this.props.mostrarDatatable ? (
          <div className="card shadow mb-4">
            <div className="card-body">
              <br />
              <table
                ref={(el) => (this.el = el)}
                border="0"
                id="tbAutorizaciones"
                className="table table-striped table-hover"
              >
                <thead>
                  <tr>
                    <th>No. Autorización</th>
                    <th>Tipo Autorización</th>
                    <th>Entidad</th>
                    <th>Tipo Persona</th>
                    <th>Identificación</th>
                    <th>Nombre</th>
                    <th>Fecha</th>
                    <th>Fecha Trámite</th>
                    <th>Usuario</th>
                    <th>Estado</th>
                    <th>Fin Relación Crediticia</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
